import React from 'react';
import { Box } from '@mui/material';
import { Default, Win01, Win02 } from '../../../assets/images/tournamentLine2';

/**
 * TournamentLine Component
 * @param {Object} props
 * @param {string} props.prop - 상태: "default" | "win 01" | "win 02"
 * @param {string} props.prop1 - 방향: "위" | "아래"
 * @param {Object} props.sx - 추가 스타일
 * @param {Object} props...props - 기타 props
 */
export const TournamentLine = ({ prop = "default", prop1 = "위", sx = {}, ...props }) => {
    const containerStyles = {
        position: 'relative',
        width: '100%',
        height: '100%',
        ...sx
    };

    // win 01 + 위
    if (prop === "win 01" && prop1 === "위") {
        return (
            <Box sx={containerStyles} {...props}>
                <Box sx={{
                    position: 'absolute',
                    bottom: '0.73%',
                    left: 0,
                    right: '4.54%',
                    top: '0.73%'
                }}>
                    <Box sx={{
                        position: 'absolute',
                        bottom: '-0.07%',
                        left: 0,
                        right: '-2.37%',
                        top: '-0.75%'
                    }}>
                        <Default
                            style={{ width: '100%', height: '100%', display: 'block' }}
                        />
                    </Box>
                </Box>
                <Box sx={{
                    position: 'absolute',
                    bottom: '0.73%',
                    left: 0,
                    right: '4.54%',
                    top: '0.73%'
                }}>
                    <Box sx={{
                        position: 'absolute',
                        bottom: '-0.07%',
                        left: 0,
                        right: '-2.37%',
                        top: '-0.75%'
                    }}>
                        <Win01
                            style={{ width: '100%', height: '100%', display: 'block' }}
                        />
                    </Box>
                </Box>
            </Box>
        );
    }

    // win 02 + 위
    if (prop === "win 02" && prop1 === "위") {
        return (
            <Box sx={containerStyles} {...props}>
                <Box sx={{
                    position: 'absolute',
                    bottom: '0.73%',
                    left: 0,
                    right: '4.54%',
                    top: '0.73%'
                }}>
                    <Box sx={{
                        position: 'absolute',
                        bottom: '-0.07%',
                        left: 0,
                        right: '-2.37%',
                        top: '-0.75%'
                    }}>
                        <Default
                            style={{ width: '100%', height: '100%', display: 'block' }}
                        />
                    </Box>
                </Box>
                <Box sx={{
                    position: 'absolute',
                    bottom: '0.73%',
                    left: 0,
                    right: '4.54%',
                    top: '19.85%'
                }}>
                    <Box sx={{
                        position: 'absolute',
                        bottom: '-0.09%',
                        left: 0,
                        right: '-2.37%',
                        top: '-0.93%'
                    }}>
                        <Win02
                            style={{ width: '100%', height: '100%', display: 'block' }}
                        />
                    </Box>
                </Box>
            </Box>
        );
    }

    // default + 아래
    if (prop === "default" && prop1 === "아래") {
        return (
            <Box sx={containerStyles} {...props}>
                <Box sx={{
                    position: 'absolute',
                    bottom: '0.73%',
                    left: 0,
                    right: '4.54%',
                    top: '0.73%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Box sx={{
                        width: '21px',
                        height: '67px',
                        transform: 'scaleY(-1)'
                    }}>
                        <Box sx={{
                            position: 'relative',
                            width: '100%',
                            height: '100%'
                        }}>
                            <Box sx={{
                                position: 'absolute',
                                bottom: '-0.07%',
                                left: 0,
                                right: '-2.37%',
                                top: '-0.75%'
                            }}>
                                <Default
                                    alt=""
                                    style={{ width: '100%', height: '100%', display: 'block' }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        );
    }

    // win 01 + 아래
    if (prop === "win 01" && prop1 === "아래") {
        return (
            <Box sx={containerStyles} {...props}>
                <Box sx={{
                    position: 'absolute',
                    bottom: '0.73%',
                    left: 0,
                    right: '4.54%',
                    top: '0.73%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Box sx={{
                        width: '21px',
                        height: '67px',
                        transform: 'scaleY(-1)'
                    }}>
                        <Box sx={{
                            position: 'relative',
                            width: '100%',
                            height: '100%'
                        }}>
                            <Box sx={{
                                position: 'absolute',
                                bottom: '-0.07%',
                                left: 0,
                                right: '-2.37%',
                                top: '-0.75%'
                            }}>
                                <Default
                                    style={{ width: '100%', height: '100%', display: 'block' }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Box sx={{
                    position: 'absolute',
                    bottom: '0.73%',
                    left: 0,
                    right: '4.54%',
                    top: '0.73%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Box sx={{
                        width: '21px',
                        height: '67px',
                        transform: 'scaleY(-1)'
                    }}>
                        <Box sx={{
                            position: 'relative',
                            width: '100%',
                            height: '100%'
                        }}>
                            <Box sx={{
                                position: 'absolute',
                                bottom: '-0.07%',
                                left: 0,
                                right: '-2.37%',
                                top: '-0.75%'
                            }}>
                                <Win01
                                    style={{ width: '100%', height: '100%', display: 'block' }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        );
    }

    // win 02 + 아래
    if (prop === "win 02" && prop1 === "아래") {
        return (
            <Box sx={containerStyles} {...props}>
                <Box sx={{
                    position: 'absolute',
                    bottom: '0.73%',
                    left: 0,
                    right: '4.54%',
                    top: '0.73%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Box sx={{
                        width: '21px',
                        height: '67px',
                        transform: 'scaleY(-1)'
                    }}>
                        <Box sx={{
                            position: 'relative',
                            width: '100%',
                            height: '100%'
                        }}>
                            <Box sx={{
                                position: 'absolute',
                                bottom: '-0.07%',
                                left: 0,
                                right: '-2.37%',
                                top: '-0.75%'
                            }}>
                                <Default
                                    style={{ width: '100%', height: '100%', display: 'block' }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Box sx={{
                    position: 'absolute',
                    bottom: '19.85%',
                    left: 0,
                    right: '4.54%',
                    top: '0.73%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Box sx={{
                        width: '21px',
                        height: '54px',
                        transform: 'scaleY(-1)'
                    }}>
                        <Box sx={{
                            position: 'relative',
                            width: '100%',
                            height: '100%'
                        }}>
                            <Box sx={{
                                position: 'absolute',
                                bottom: '-0.09%',
                                left: 0,
                                right: '-2.37%',
                                top: '-0.93%'
                            }}>
                                <Win02
                                    style={{ width: '100%', height: '100%', display: 'block' }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        );
    }

    // 기본 상태 (default + 위)
    return (
        <Box sx={containerStyles} {...props}>
            <Box sx={{
                position: 'absolute',
                bottom: '0.73%',
                left: 0,
                right: '4.54%',
                top: '0.73%'
            }}>
                <Box sx={{
                    position: 'absolute',
                    bottom: '-0.07%',
                    left: 0,
                    right: '-2.37%',
                    top: '-0.75%'
                }}>
                    <Default
                        alt=""
                        style={{ width: '100%', height: '100%', display: 'block' }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default TournamentLine;
